'use client';

import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { usePreferences } from '@/context/PreferencesContext';
import { useAuth } from '@/context/AuthContext';
import { getAdSlots } from '@/lib/api-client';
import type { AdSlot } from '@/lib/api-client';
import TopAdBanner from './TopAdBanner';
import { isAdExcluded, useGlobalAdExclusions } from '@/hooks/useAdsConfig';

export default function AdBannerWrapper() {
  const { showAds } = usePreferences();
  const { isPro, loading } = useAuth();
  const pathname = usePathname();
  const [topBanner, setTopBanner] = useState<AdSlot | undefined>(undefined);
  const globalExcluded = useGlobalAdExclusions();

  // Free users: always show ads (toggle disabled)
  // Pro users: ads off by default, can opt-in via toggle
  const shouldShowAds = isPro ? showAds : true;

  useEffect(() => {
    if (loading || !shouldShowAds) return;
    getAdSlots()
      .then((slots) => {
        setTopBanner(slots.find((s) => s.slotName === 'top-banner'));
      })
      .catch(() => {});
  }, [loading, shouldShowAds]);

  if (loading) return null;
  const hideOnPages = ['/login', '/create-account', '/verify-email', '/forgot-password', '/reset-password', '/admin'];
  if (!shouldShowAds) return null;
  if (hideOnPages.some((p) => pathname === p || pathname.startsWith(p + '/'))) return null;
  if (isAdExcluded(topBanner?.excludedPages ?? [], globalExcluded, pathname)) return null;
  return <TopAdBanner slot={topBanner} />;
}
